import { Form, Input, InputNumber, Select, Row, Col } from 'antd';
import { useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import getList from '../../universal/getList';
import system from "../../../config/systematic";
import WebIngredientFormList from '../../generalComponents/WebIngredientFormList';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

const { Option } = Select;

export default function CopyIngredient(props: any) {

    const [form] = Form.useForm(); //form 
    const { data, closeModal } = props;
    const ref = useRef<any>(undefined);
    const notificationApi = useNotificationInstance();

    /** 后端数据Service */
    let wmService = system.wmService;

    /**计算毛利率 */
    const setPersent = (form: any, e: any) => {
        let grossProfitRatio: any = (e - form.getFieldValue("costPrices")) / e * 100;
        form.setFieldsValue({ grossProfitRatio: grossProfitRatio.toFixed(2) });
    }

    /** 基础数据*/
    const [ingredientBaseData, setIngredientBaseData] = useState<any>(data.type === "COPY" ? true : false);

    /** 单位数据 */
    const [productUnitData, setProductUnitData] = useState<any>();

    /** 主配料数据 */
    const [ingredientData, setIngredientData] = useState<any>([]);

    const [loadingData, setLoadingData] = useState<any>(false);

    const [monthsBackData, setMonthsBackData] = useState<any>(3);

    /** 门店数据 */
    const [branchStoreData, setBranchStoreData] = useState<any>();

    const [stepData, setStepData] = useState<any>(5);

    const [refreshData, setRefreshData] = useState<any>(false);

    const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<any>();

    /** 福食菜品智库数据 */
    const [feastTeamMenuWarehouseData, setFeastTeamMenuWarehouseData] = useState<any>();

    /** 门店菜式规格数据 */
    const [branchStoreMenuWarehouseSpecData, setBranchStoreMenuWarehouseSpecData] = useState<any>();

    /** 成本预警峰值最低值 */
    const [minWarningData, setMinWarningData] = useState<any>(0);

    /** 成本预警峰值最高值 */
    const [maxWarningData, setMaxWarningData] = useState<any>(100);

    /** 福食菜品智库和门店菜式的显示状态 */
    const [isBranchStoreMenuWarehouseDisable, setIsBranchStoreMenuWarehouseDisable] = useState<any>(false);

    /** 合并数据 */
    const [ingredientDetailData, setIngredientDetailData] = useState<any>([]);

    const [tempDeleteData, setTempDeleteData] = useState<any>();

    const [formList, setFormList] = useState<any>({ form, type: data.type, ref, setIngredientDetailData, setTempDeleteData, setPersent, setRefreshData })

    const getListDisabled = (rows: any, itemName: string) => {
        // console.log(rows);
        if (typeof rows !== "undefined") {
            if (rows.constructor === Object) {
                rows = [rows]
            } else {
                rows = rows
            }
            if (rows.length === undefined) { return undefined }

            return (rows.map((item: any, key: number) => {
                return <Option
                    value={item.id}
                    key={key}
                    obj={{ menuWarehouseSpecId: item.menuWarehouseSpecId, price: item.price, branchStoreMenuWarehouseSpecName: item.branchStoreMenuWarehouseSpecName }}
                    disabled={inArray(item.id, item.menuWarehouseIngredients)}
                >
                    {item[itemName]} {(form.getFieldsValue()['sellPrice'] !== undefined && form.getFieldsValue()['sellPrice'] !== item.price) ? <span style={{ color: 'yellow' }}>（ 现门店设置售价为 {item.price} ）</span> : ''}
                </Option>
            }))
        }
    };

    //查询该规格是否在已设置主配料
    const inArray = (search: any, array: any) => {
        // console.log("-----------------------------------------");
        for (var i in array) {
            // console.log("inarray 里面循环第 " + i + " 次")
            // console.log("数据库里面的数据 " + array[i])
            // console.log("现在提交的数据是 " + search)
            if (array[i].branchStoreMenuWarehouseSpecId === search) {
                return true;
            }
        }
        // console.log("-----------------------------------------")
        return false;
    }

    //选择规格后，把菜品智库规格填入
    const selectSpec = async (e: any, option: any, form?: any) => {
        form.setFieldsValue({ menuWarehouseSpecId: option.obj.menuWarehouseSpecId });
        form.setFieldsValue({ sellPrice: option.obj.price });
        form.setFieldsValue({ branchStoreMenuWarehouseSpecName: option.obj.branchStoreMenuWarehouseSpecName });

        // form.setFieldsValue({ branchStoreMenuWarehouseSpecName: option.children[0] });

        setPersent(form, option.obj.price);
        setRefreshData(true);
    }

    //选择门店
    const selectBranchStore = () => {
        setStepData(7);
    }

    //选择门店菜式
    const selectBranchStoreMenuWarehouse = (e: any) => {
        fetchApi.GET(wmService, {
            apiId: 'branchStoreMenuWarehouseSpec',
            apiExtend: 'checkBranchStoreMenuWarehouseSpec',
            branchStoreMenuWarehouseId: e,
        }).then(res => {
            if (res.success) {
                setBranchStoreMenuWarehouseSpecData(res.data);
                if (res.data.length === 1) {
                    form.setFieldsValue({ branchStoreMenuWarehouseSpecId: res.data[0].id });
                    form.setFieldsValue({ sellPrice: res.data[0].price });

                    form.setFieldsValue({ menuWarehouseId: res.data[0].branchStoreMenuWarehouse.menuWarehouseId });
                    form.setFieldsValue({ menuWarehouseSpecId: res.data[0].menuWarehouseSpecId });
                    form.setFieldsValue({ foodName: res.data[0].branchStoreMenuWarehouse.foodName });
                    form.setFieldsValue({ branchStoreMenuWarehouseSpecName: res.data[0].branchStoreMenuWarehouseSpecName });

                    setPersent(form, res.data[0].price);
                    setRefreshData(true);
                }
                else {
                    form.setFieldsValue({ foodName: res.data[0].branchStoreMenuWarehouse.foodName });
                    form.setFieldsValue({ menuWarehouseId: res.data[0].branchStoreMenuWarehouse.menuWarehouseId });
                }
            }
        });
        setStepData(8);
    }

    //选择福食菜式
    const selectFeastTeamMenuWarehouse = (e: any, option: any) => {
        console.log(option);
        form.setFieldsValue({ productUnitId: option.productUnitId });
        form.setFieldsValue({ feastTeamMenuWarehouseProductUnitName: option.productUnitName });
        form.setFieldsValue({ foodName: option.label });
        setRefreshData(true);
        // setStepData(2);
    }

    /**数据 */
    useEffect(() => {
        const fetchData = async () => {
            if (data.path === 'BranchStoreMenuWarehouse') {
                setIsBranchStoreMenuWarehouseDisable(true);
                setStepData(6);
            }
            else {
                setIsBranchStoreMenuWarehouseDisable(false);
                setStepData(1)
            }

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseIngredient",
                apiExtend: "showSingle",
                apiVariable: data.id,
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isBranchStore: true
                        }
                    }
                }
            }).then(async res => {
                if (res.success) {
                    form.setFieldsValue({ costPrices: res.data.costPrices });
                    form.setFieldsValue({ minWarning: res.data.minWarning });
                    form.setFieldsValue({ maxWarning: res.data.maxWarning });
                    form.setFieldsValue({ standardGrossProfitRatio: res.data.standardGrossProfitRatio });

                    // let new_arr = [];
                    // let str_arr: any = [];

                    // /** 点击复制后，根据数据的内容来进行分析，筛选出之前有数据的口味 */
                    // for (var i_data = 0, len_data = res.data.length; i_data < len_data; i_data++) {
                    //     let str_data = "ingredient" + i_data;
                    //     form.setFieldsValue({ [str_data]: i_data });

                    //     if (res.data[i_data].length === 0) {
                    //         str_arr.push(i_data);
                    //     }
                    //     else {
                    //         str_arr.push(999);
                    //     }
                    // }

                    // await fetchApi.GET(wmService, {
                    //     apiId: 'generalData',
                    //     apiVariable: 'ingredient',
                    //     apiExtend: 'showList'
                    // }).then(ress => {
                    //     new_arr = ress.data.map((item: any) => ({
                    //         id: item.id,                      //设置字段，在form.list下的form.item中指定的字段值
                    //         name: item.name,
                    //         visible: str_arr[item.id] === item.id ? false : item.visible
                    //     }));
                    //     setIngredientData(new_arr);
                    // });
                }
            });

            fetchApi.GET(wmService, {
                apiId: 'generalData',
                apiVariable: 'ingredient',
                apiExtend: 'showList'
            }).then(res => {
                setIngredientData(res.data);
                // let ingredient_arr = [];
                // for (var ingredientid = 0, ingredientlen = res.data.length; ingredientid < ingredientlen; ingredientid++) {
                //     ingredient_arr.push([]);
                // }

                // for (var i = 0, len = res.data.length; i < len; i++) {
                //     let str_data = "ingredient" + res.data[i].id;
                //     form.setFieldsValue({ [str_data]: res.data[i].id });
                // }
            });

            fetchApi.GET(wmService, {
                apiId: "productUnit",
                apiExtend: 'showList'
            }).then(res => {
                setProductUnitData(res.data);
            });

            fetchApi.GET(wmService, {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            }).then(res => {
                setBranchStoreData(res.data);
            });
        }
        fetchData()
    }, [])

    const handleOk = (e: any) => {
        setLoadingData(true);
        form.validateFields() //数据校验
            .then(async (values: any) => {
                let nowData = { ...values, totalData: ingredientDetailData };
                const editData = {
                    ...nowData
                }
                fetchApi.POST(wmService, {
                    apiId: "menuWarehouseIngredient",
                    apiExtend: "create",
                    apiData: { ...editData }
                }).then(res => {
                    if (res.success) {
                        antMessage('success', '复制成功', 'success');
                        closeModal(true);
                    }
                }).catch(err => {
                    setLoadingData(false);
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            })
            .catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
                setLoadingData(false);
            });
    };

    const updateWarning = async (e: any) => {
        form.setFieldsValue({ minWarning: Number(e) - 5 < 0.01 ? 0.01 : Number(e) - 5 });
        form.setFieldsValue({ maxWarning: Number(e) + 5 > 99.99 ? 99.99 : Number(e) + 5 });
    }

    const checkWaring = async (key: string, e: any) => {
        switch (key) {
            case 'minWarning':
                setMinWarningData(e);
                // if (e > form.getFieldsValue()['maxWarning']) {
                //     form.setFieldsValue({ minWarning: form.getFieldsValue()['maxWarning'] });
                // }
                break;
            case 'maxWarning':
                setMaxWarningData(e);
                // if (e < form.getFieldsValue()['minWarning']) {
                //     form.setFieldsValue({ maxWarning: form.getFieldsValue()['minWarning'] });
                // }
                break;
        }
    }

    const handleCancel = (e: any) => {
        closeModal(true);
    };

    //格式化数字
    const formatNumber = async (e: any) => {
        setMonthsBackData(parseInt(e));
        form.setFieldsValue({ monthsBack: parseInt(e) });
    }

    return (
        <>
            <AntDraggableModal
                title={"复制主配料"}
                open={true}
                okText='确定'
                cancelText='取消'
                okButtonProps={{ disabled: loadingData }}
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1100}
                confirmLoading={loadingData}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="菜品智库id"
                                name="menuWarehouseId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="菜品智库规格id"
                                name="menuWarehouseSpecId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={isBranchStoreMenuWarehouseDisable && stepData >= 6 ? 24 : 0}>
                            <Form.Item
                                label="门店"
                                name="branchStoreId"
                                rules={[{
                                    required: isBranchStoreMenuWarehouseDisable ? true : false,
                                    message: '请选择门店!'
                                }]}>
                                <Select
                                    disabled={stepData > 6 ? true : false}
                                    showSearch
                                    placeholder="门店"
                                    onChange={selectBranchStore}
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(branchStoreData, {
                                        itemName: "branchStoreName",
                                        setItemNameFun: (item: any) => {
                                            let name = '';
                                            if (item) {
                                                const { brandName } = item;
                                                if (brandName) {
                                                    name = `【 ${brandName} 】`;
                                                }
                                                name += item.branchStoreName;
                                            }
                                            return name;
                                        },
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={isBranchStoreMenuWarehouseDisable && stepData >= 7 ? 12 : 0}>
                            <Form.Item
                                label="菜式"
                                name="branchStoreMenuWarehouseId"
                                rules={[{
                                    required: isBranchStoreMenuWarehouseDisable ? true : false,
                                    message: '请选择菜式!'
                                }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="菜式"
                                    disabled={stepData > 7 ? true : false}
                                    onSearch={(e) => getList.searchEx('branchStoreMenuWarehouse', setBranchStoreMenuWarehouseData, e, branchStoreMenuWarehouseData, {
                                        apiExtend: 'showMenuList',
                                        andWhereObj: {
                                            branchStoreId: form.getFieldsValue()['branchStoreId'],
                                            mountDataOptions: {
                                                userMount: {
                                                    isDept: true
                                                }
                                            }
                                        }
                                    })}
                                    onSelect={selectBranchStoreMenuWarehouse}
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                >
                                    {/* {getList.generalEx(branchStoreMenuWarehouseData, {
                                        itemName: "foodName",
                                        includeNull: false,
                                    })} */}

                                    {getList.generalEx(branchStoreMenuWarehouseData, {
                                        itemName: 'foodName',
                                        setItemNameFun: (item: any) => {
                                            let name = '';
                                            if (item) {
                                                const { productUnit } = item;
                                                if (productUnit) {
                                                    name = ` ( ${productUnit.productUnitName} ) `;
                                                }
                                                name = item.foodName + name;
                                            }
                                            return name;
                                        }
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* 以下部分是福食信息 */}
                        <Col span={!isBranchStoreMenuWarehouseDisable && stepData >= 1 ? 12 : 0}>
                            <Form.Item
                                label="福食菜式"
                                name="feastTeamMenuWarehouseId"
                                rules={[{
                                    required: isBranchStoreMenuWarehouseDisable ? false : true,
                                    message: '请选择福食菜式!'
                                }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="福食菜式"
                                    disabled={stepData > 1 ? true : false}
                                    onSearch={(e) => getList.searchEx('feastTeamMenuWarehouse', setFeastTeamMenuWarehouseData, e, feastTeamMenuWarehouseData, {
                                        apiExtend: 'showFeastTeamList',
                                        andWhereObj: {
                                            mountDataOptions: {
                                                userMount: {
                                                    isBranchStore: true
                                                }
                                            }
                                        }
                                    })}
                                    onSelect={selectFeastTeamMenuWarehouse}
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                    options={feastTeamMenuWarehouseData}
                                >
                                    {/* {getList.generalEx(feastTeamMenuWarehouseData, {
                                        itemName: "foodName",
                                        includeNull: false,
                                    })} */}
                                </Select>
                            </Form.Item>
                        </Col>
                        {/* 以上部分是福食信息 */}

                        <Col span={12}>
                            <Form.Item
                                label="售价 (元)"
                                name="sellPrice"
                                rules={[{ required: true, message: '请输入售价!' }]}>
                                <InputNumber style={{ color: 'white', fontSize: '15px', backgroundColor: 'blue' }} min={0} onChange={(e) => setPersent(form, e)} disabled={isBranchStoreMenuWarehouseDisable} />
                            </Form.Item>
                        </Col>

                        {/* 以下部分是福食信息 */}
                        <Col span={!isBranchStoreMenuWarehouseDisable && stepData >= 1 ? 0 : 0}>
                            <Form.Item
                                label="福食规格"
                                name="productUnitId"
                            >
                                <Select
                                    disabled
                                    showSearch
                                    placeholder="规格"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(productUnitData, 'productUnitName')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={!isBranchStoreMenuWarehouseDisable && stepData >= 1 ? 12 : 0}>
                            <Form.Item
                                label="福食规格"
                                name="feastTeamMenuWarehouseProductUnitName"
                            >
                                <Input style={{ color: 'yellow' }} disabled />
                            </Form.Item>
                        </Col>
                        {/* 以上部分是福食信息 */}

                        <Col span={isBranchStoreMenuWarehouseDisable && stepData >= 8 ? 12 : 0}>
                            <Form.Item
                                label="规格"
                                name="branchStoreMenuWarehouseSpecId"
                                rules={[{
                                    required: isBranchStoreMenuWarehouseDisable ? true : false,
                                    message: '请输入规格!'
                                }]}>
                                <Select
                                    disabled={stepData > 8 ? true : false}
                                    showSearch
                                    placeholder="规格"
                                    onChange={(e, option) => selectSpec(e, option, form)}
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getListDisabled(branchStoreMenuWarehouseSpecData, 'branchStoreMenuWarehouseSpecName')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="菜式名称"
                                name="foodName">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="菜式规格名称"
                                name="branchStoreMenuWarehouseSpecName">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="成本 (元)"
                                name="costPrices"
                                rules={[{ required: true, message: '请填写成本!' }]}>
                                <InputNumber style={{ color: 'white', fontSize: '15px', backgroundColor: 'blue' }} min={0} disabled />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="标准毛利率 (%)"
                                name="standardGrossProfitRatio"
                                rules={[{ required: true, message: '请填写标准毛利率!' }]}>
                                <InputNumber onChange={updateWarning} min={0.01} max={99.99} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="毛利预警范围 (%)" >
                                <Form.Item
                                    name="minWarning"
                                    style={{ display: 'inline-block' }}
                                    rules={[{ required: true, message: '请输入毛利预警最低值!' }]}
                                >
                                    <InputNumber min={0} max={maxWarningData} onChange={(e) => checkWaring("minWarning", e)} />
                                </Form.Item>
                                &nbsp;
                                ~
                                &nbsp;
                                <Form.Item
                                    name="maxWarning"
                                    style={{ display: 'inline-block' }}
                                    rules={[{ required: true, message: '请输入毛利预警最高值!' }]}
                                >
                                    <InputNumber min={minWarningData} max={100} onChange={(e) => checkWaring("maxWarning", e)} />
                                </Form.Item>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="毛利率 (%)"
                                name="grossProfitRatio"
                                rules={[{ required: true, message: '请填写毛利率!' }]}>
                                <InputNumber style={{ color: 'white', fontSize: '15px', backgroundColor: 'blue' }} min={0.01} max={99.99} disabled />
                            </Form.Item>
                        </Col>
                    </Row>

                    <br></br>

                    <Row gutter={[8, 0]}>
                        <Col span={2}> </Col>
                        <Col span={4}>原材料</Col>
                        <Col span={2}>单位</Col>
                        <Col span={2}>定量</Col>
                        <Col span={2}>起率&nbsp;(%)</Col>
                        <Col span={2}>&nbsp;&nbsp;&nbsp;&nbsp;单价</Col>
                        <Col span={2}>&nbsp;&nbsp;&nbsp;&nbsp;金额</Col>
                        <Col span={4}>&nbsp;&nbsp;&nbsp;&nbsp;自动更新</Col>
                        <Col span={2}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备注</Col>

                        {
                            ingredientData.length > 0 ? ingredientData.map((item: any, index: any) => {
                                return (
                                    <>
                                        <Col span={24}>
                                            <Row gutter={[8, 0]}>
                                                <Col span={0}>
                                                    <Form.Item
                                                        //label={item.name}
                                                        name={"ingredient" + item.id}
                                                    >
                                                        <Select
                                                            showSearch
                                                            disabled
                                                            placeholder={item.name}
                                                            optionFilterProp="children"
                                                            filterOption={(input, option: any) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                            {getList.general(ingredientData, 'name')}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                                <Col span={24}><Input style={{ color: 'yellow' }} value={item.name} disabled /></Col>
                                                <Col span={24}> </Col>
                                                <Col span={24}> </Col>
                                                <Col span={24}> </Col>
                                                <Col span={24}> </Col>

                                                <Col span={24}>
                                                    <WebIngredientFormList props={formList} formName={'ingredientDetail' + item.id} isBase={ingredientBaseData} ingredient={item.id} ingredientLength={ingredientData.length} tempDeleteData={tempDeleteData} parentData={data} monthsBack={monthsBackData} refreshData={refreshData} ></WebIngredientFormList>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </>
                                )
                            })
                                : null
                        }
                    </Row>

                    <Row gutter={[8, 0]}>
                        <Col span={8}>
                            <Form.Item
                                label="时段"
                                tooltip='获取几个月内的单价'
                                name="monthsBack">
                                <InputNumber onChange={formatNumber} max={36} min={3} defaultValue={3} addonAfter=" 个月" step={1} style={{ width: 120 }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}